/* unplugin-vue-components disabled */import script from "./category.vue?vue&type=script&setup=true&lang=ts"
export * from "./category.vue?vue&type=script&setup=true&lang=ts"

import "./category.vue?vue&type=style&index=0&id=f7b6911a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7b6911a"]])

export default __exports__